import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Modal from '../Modal';
import Input from '../../../atoms/inputs/Input';
import SelectWithValues from '../../../atoms/selects/SelectWithValues';
import LabelWithToggle from '../../../molecules/labels/LabelWithToggle';
import Button from '../../../atoms/buttons/Button';
import Paragraph from '../../../atoms/paragraphs/Paragraph';

const AddEditTaxModal = (props) => {
  const {
    showModal,
    changeModalVisibility,
    isLoading,
    isEdit,
    numTaxes,
    name,
    nameError,
    value,
    region,
    code,
    regions,
    codes,
    isDefault,
    onChangeField,
    saveTax,
    deleteTax,
  } = props;

  const cssClass = showModal ? 'd-block' : 'd-none';
  const [defaultUnchanged] = useState(isDefault);
  const [parsedValue, setParsedValue] = useState('');

  const handleValueChange = (value) => {
    let filteredValue = value;

    if (filteredValue === '') {
      onChangeField('value', '');
      return;
    }

    filteredValue = filteredValue.replace(/[^0-9,.]/g, '');

    const commaIndex = filteredValue.indexOf(',');
    const periodIndex = filteredValue.indexOf('.');

    if (commaIndex !== -1 && periodIndex !== -1) {
      if (commaIndex < periodIndex) {
        filteredValue = filteredValue.replace(/\./g, '');

        filteredValue =
          filteredValue.substring(0, commaIndex + 1) +
          filteredValue.substring(commaIndex + 1).replace(/,/g, '');
      } else {
        filteredValue = filteredValue.replace(/,/g, '');

        filteredValue =
          filteredValue.substring(0, periodIndex + 1) +
          filteredValue.substring(periodIndex + 1).replace(/\./g, '');
      }
    } else if (commaIndex !== -1) {
      filteredValue =
        filteredValue.substring(0, commaIndex + 1) +
        filteredValue.substring(commaIndex + 1).replace(/,/g, '');
    } else if (periodIndex !== -1) {
      filteredValue =
        filteredValue.substring(0, periodIndex + 1) +
        filteredValue.substring(periodIndex + 1).replace(/\./g, '');
    }

    onChangeField('value', filteredValue);
  };

  useEffect(() => {
    setParsedValue(value.split(' ')[0]);
  }, [value]);

  return (
    <Modal isLoading={isLoading} className={`${cssClass}`}>
      <div className='--tax-modal'>
        <div className='text-header h2 text-center'>
          {props.intl.messages[isEdit ? 'taxesEditTax' : 'taxesNewTax']}
        </div>

        <div className='col-12 px-0 mb-4'>
          <label className='text-label' htmlFor='tax_name'>
            {props.intl.messages['taxesName'] + '*:'}
          </label>
          <Input
            id='tax_name'
            type='text'
            value={name || ''}
            onChange={(e) => onChangeField('name', e.target.value)}
          />
          {(nameError && (
            <Paragraph className='font-bold color-error mt-2'>
              {props.intl.messages['taxesSameNameError']}
            </Paragraph>
          )) || <></>}
        </div>

        <div className='col-12 px-0 mb-2'>
          <label className='text-label' htmlFor='tax_value'>
            {props.intl.messages['taxesValue'] + '*:'}
          </label>
          <Input
            id='tax_value'
            type='text'
            inputMode='decimal'
            value={parsedValue || ''}
            onChange={(e) => handleValueChange(e.target.value)}
          />
        </div>

        <div className='d-flex w-100'>
          <Paragraph className='text-label ms-auto mt-0 mb-3'>
            *{props.intl.messages['requiredFields']}
          </Paragraph>
        </div>

        <div className='col-12 px-0 mb-4'>
          <label className='text-label' htmlFor='tax_region'>
            {props.intl.messages['taxesRegion'] + ':'}
          </label>
          <SelectWithValues
            id='tax_region'
            options={regions.map((region) => ({
              key: region.name,
              value: region.region,
            }))}
            value={JSON.stringify({
              key: region.name,
              value: region.region,
            })}
            onChange={(e) =>
              onChangeField('region', JSON.parse(e.target.value).value)
            }
            isObject
          />
        </div>

        <div className='col-12 px-0 mb-4'>
          <label className='text-label' htmlFor='tax_code'>
            {props.intl.messages['taxesCode'] + ':'}
          </label>
          <SelectWithValues
            id='tax_code'
            options={codes.map((code) => ({
              key: code.name,
              value: code.code,
            }))}
            value={JSON.stringify({
              key: code.name,
              value: code.code,
            })}
            onChange={(e) =>
              onChangeField('code', JSON.parse(e.target.value).value)
            }
            isObject
          />
        </div>

        <LabelWithToggle
          className='mb-3'
          label='taxesMakeDefault'
          toggleID='iva_toggle'
          isChecked={isDefault}
          onChange={() => onChangeField('default_tax', !isDefault)}
          disabled={defaultUnchanged}
        />

        <div className='d-flex flex-column w-100 justify-content-center'>
          <div className='d-flex w-100 justify-content-center'>
            <Button
              id='cancel-action'
              className='button button-outline me-4 w-100'
              onClick={changeModalVisibility}
            >
              <FormattedMessage id={'cancelAction'} />
            </Button>

            <Button
              id='taxes-save'
              className='button button-primary ms-4 w-100'
              onClick={saveTax}
              disabled={!name || !value || nameError}
            >
              <FormattedMessage id={'taxesSave'} />
            </Button>
          </div>

          {(isEdit && (
            <div className='d-flex w-100 justify-content-center'>
              <Button
                id='taxes-delete'
                className='button button-plain-text mt-4 w-100'
                onClick={deleteTax}
                disabled={numTaxes === 1}
              >
                <FormattedMessage id={'taxesDelete'} />
              </Button>
            </div>
          )) || <></>}
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(AddEditTaxModal);
